export default "__VITE_ASSET__DgrIBqq2__"